import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { user } from "../../utils/constant";
import Admin from "./Admin";
import "./dashboard.css";
import SuperAdmin from "./super-admin/SuperAdmin";

const HTA_HOME_PATH = "/programs?type=yettojoin&page=1";

export const Dashboard = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const role = userInfo.data.role;

  if (role === "") return <></>;

  if (role === user.hta) {
    return <Navigate to={HTA_HOME_PATH} replace />;
  }

  return (
    <div>
      {role === user.admin && <Admin />}
      {role === user.super_admin && <SuperAdmin />}
    </div>
  );
};
